// extracted by mini-css-extract-plugin
export default {"fileImage":"FileImageThumbnail_fileImage__WyZFr","fileImageWrapper":"FileImageThumbnail_fileImageWrapper__tLqVO","errorIcon":"FileImageThumbnail_errorIcon__hyqK2"};